import styles from './Recaptcha.module.css'

import classnames from 'classnames'
import {FieldValidator} from 'final-form'
import React, {useCallback, useImperativeHandle, useRef} from 'react'
import {Field} from 'react-final-form'
import {useIntl} from 'react-intl'
import axios from "axios";
import { off } from 'process'

interface IRecaptchaProps {
    token?: string
    image?: string
    label?: string
    className?: string
    name: string
    placeholder?: string
    optional?: boolean
    ariaDescription?: string
    type?: 'date' | 'text' | 'number'
    disabled?: boolean,
    hidden?: boolean,
    maxLength?: number,
    dependantValue?: any,
    validate?: FieldValidator<string>
    onBlur?: (event: React.FocusEvent<HTMLElement> | undefined) => void,
}

export const Recaptcha: React.FC<IRecaptchaProps> = ({
    token,
    image,
    type = 'text',
    disabled = false,
    hidden = false,
    optional = false,
    name,
    label,
    placeholder,
    ariaDescription,
    className = '',
    validate = undefined,
    onBlur = _ => {},
    maxLength
                                                     }) => {
    const imageRef = useRef(image);
    const tokenRef = useRef(token);
    const forceUpdate = React.useReducer(() => ({}), {})[1] as () => void;

    const requiredValidation = useCallback((value: string, _allValues: any) => {
        _allValues["captcha-token"] = tokenRef.current;
        if (!optional && (value == null || value === '')) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [optional])

    const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
        const validations: Array<FieldValidator<string>> = []

        if (!optional) {
            validations.push(requiredValidation)
        }
        if (validate != null) {
            validations.push(validate)
        }

        return validations.reduce((message: string | undefined, fn) => (
            message == null
                ? fn(value, allValues)
                : message
        ), undefined)
    })

    function reloadCaptcha() {
        axios.get(
            //"http://localhost:5000/v/1/integrator/captcha",
            //"https://e-usluge-test.mirovinsko.hr/v/1/integrator/captcha",
            window.location.origin + "/v/1/integrator/captcha",
            //"https://e-usluge-test.mirovinsko.hr/v/1/integrator/captcha",
            {headers: {'content-type': 'application/json'}},
        ).then(r => {
            imageRef.current = "data:image/png;base64," + r?.data.Image;
            tokenRef.current = r?.data.Token;
            forceUpdate();
        });
    }

    React.useEffect(( ) => {
        reloadCaptcha();
    }, []);

    return (
        <Field
            name={name}
            validate={validatorRef.current}
        >
            {({input, meta}) => (
                <div className={classnames(styles.Input, className)}>
                    {label && !hidden && <label htmlFor={name}>{optional ? label : label + " *"}</label> }
                    <div className="row">
                    <img style={{marginLeft:"10px",marginBottom: "10px"}} src={imageRef.current}/>
                    <div onClick={reloadCaptcha} id={"refresh-captcha-id"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                            <path
                                d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                            <path fillRule="evenodd"
                                  d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                        </svg>
                    </div>
                    </div>
                            <input
                                className={classnames({'form-control': true, 'is-invalid': meta.touched && meta.error})}
                                type={type}
                                {...input}
                                placeholder={placeholder}
                                aria-describedby={ariaDescription}
                                disabled={disabled}
                                hidden={hidden}
                                autoComplete={"off"}
                                maxLength={maxLength}
                                onBlur={(value: React.FocusEvent<HTMLElement> | undefined) => {
                                    input.onBlur(value);
                                    if (onBlur !== undefined) {
                                        onBlur(value);
                                    }
                                }}

                            />
                            {meta.touched && meta.error && <div className='invalid-feedback'>{meta.error} '{label?.replace(":", "")}'</div>}
                            {ariaDescription && (
                                <span
                                    id={`help-${name}`}
                                    className={classnames('form-text text-muted', styles.AriaDescription)}
                                >
                    {ariaDescription}
                        </span>
                            )}
                    <input type={"hidden"} name={"captcha-token"} value={tokenRef.current}/>

                </div>
            )}
        </Field>
    )
}
